<app-citizen-header></app-citizen-header>
<div class="bg-white">
  <div class=" p-3 md:p-5">
    <!--BEGIN: The services heading-->
    <div class="py-2 move-left  cursor-pointer flex items-center">
      <button class="button mr-2" routerLink="/home">
        <div class="button-box">
          <span class="button-elem">
            <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z">
              </path>
            </svg>
          </span>
          <span class="button-elem">
            <svg viewBox="0 0 46 40" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M46 20.038c0-.7-.3-1.5-.8-2.1l-16-17c-1.1-1-3.2-1.4-4.4-.3-1.2 1.1-1.2 3.3 0 4.4l11.3 11.9H3c-1.7 0-3 1.3-3 3s1.3 3 3 3h33.1l-11.3 11.9c-1 1-1.2 3.3 0 4.4 1.2 1.1 3.3.8 4.4-.3l16-17c.5-.5.8-1.1.8-1.9z">
              </path>
            </svg>
          </span>
        </div>
      </button>
    </div>

    <div class="mt-3 md:p-5 flex items-center justify-center">

      <div class="grid grid-cols-1 w-full md:w-2/3 md:grid-cols-2 gap-6 items-start">

        <div class="px-3 contact-card move-left">
          <h1 id="service-header">Get In Touch</h1>
          <p>Feel free to reach out for inquiries, we're here to assist you.</p>

          <form>
            <div class="form-group mt-2">
              <label for="fullName" class="block mb-2 text-sm font-medium text-gray-900">Your Name</label>
              <input type="text" id="fullName" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="John Doe" required />
            </div>
            <div class="form-group">
              <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Your email</label>
              <input type="email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="name@gmail.com" required />
            </div>
            <div class="form-group">
              <label for="email" class="block mb-2 text-sm font-medium text-gray-900">Phone Number</label>
              <input type="text" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="255712345678" required />
            </div>
            <div class="form-group">
              <label for="message" class="block mb-2 text-sm font-medium text-gray-900">Your message</label>
              <textarea id="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 " placeholder="Leave a comment..."></textarea>
            </div>
            <div class="flex mt-2 justify-end">
              <button class="bg-primary-500 p-2 rounded-md text-white" type="submit">Send</button>
            </div>
          </form>
        </div>
        <div class="bg-primary-500 move-left p-4 rounded-md text-white">
            <h1 class="font-bold mb-4">Adress</h1>
            <div class="flex items-center mb-2">
              <mat-icon svgIcon="location" class="mr-2" style="height: 25px; width: 25px;"></mat-icon>
              <span>Dodoma, Dodoma, Tanzania</span>
            </div>
            <div class="flex items-center mb-2">
              <mat-icon svgIcon="email" class="mr-2" style="height: 25px; width: 25px;"></mat-icon>
              <span>info&#64;tgsd.go.tz</span>
            </div>
            <div class="flex items-center mb-2">
              <mat-icon svgIcon="phone" class="mr-2" style="height: 25px; width: 25px;"></mat-icon>
              <span>(+255) 7123 45678</span>
            </div>
        </div>
      </div>
    </div>
  </div>
  <app-portal-footer></app-portal-footer>
</div>
